import { formatScore } from '@/utils'

export function parseScoreProgress(progress: number): string {
  if (Number(progress) === 0) return '--%'
  return `${formatScore(progress)}%`
}
